import   axios                          from 'axios';

import { API_URLS                    }  from '../urls';

import { BackendResponse             , 
         handleError                 }  from '../../dataTypes/backendServicesManagment/types';
		 
import { LegalStructure              ,
         initializedLegalStructure   ,
         StaffMember                 ,
         BusinessDocument            ,
         GetLegalStructureListParams }  from '../../dataTypes/legalStructureManagment/types';
		 
import { convertStringToDate         }  from '../../dataTypes/timeManagment/utils';

export interface BackendResponse_LegalStructure extends BackendResponse<LegalStructure[]> {}

export const getLegalStructures = async ( legalStructureCreationParams?: GetLegalStructureListParams ): Promise<BackendResponse_LegalStructure> => {

  const url = API_URLS.getLegalStructures;

  try 
   {
    const response = await axios.get(url);

    console.log ('getLegalStructures', response)

    if (response.status === 200) 
	 {
      const legalStructures: LegalStructure[] = (response.data ?? []).map((ls: any) => {

        const def = initializedLegalStructure();

        const toNum = (v: any): number => {
          const n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
          return Number.isFinite(n) ? n : 0;
        };

        const toDateOrNull = (s: any): Date | null => convertStringToDate(s) ?? null;

        const staffMembers: StaffMember[] = Array.isArray(ls.staffMembers)
          ? ls.staffMembers.map((m: any) => ({

              id          : typeof m.id === 'number' ? m.id : (typeof m.userId === 'number' ? m.userId : undefined),
              userId      : typeof m.userId === 'number' ? m.userId : 0,
              firstname   : m.firstname ?? '',
              lastname    : m.lastname ?? '',
              jobTitle    : m.jobTitle ?? '',
              email       : m.email ?? '',
              phoneNumber : m.phoneNumber ?? '',
            }))
          : [];

        const businessDocuments: BusinessDocument[] = Array.isArray(ls.businessDocuments)
          ? ls.businessDocuments
              .map((d: any) => {
                if (typeof d === 'number') {
                  return {
                    id: d,
                    name: '',
                    fileName: '',
                    fileType: '',
                    creationDate: new Date(0), // placeholder si l'API ne renvoie que l'id
                  } as BusinessDocument;
                }
                const parsedDate = convertStringToDate(d?.creationDate);
                return {
                  id: typeof d?.id === 'number' ? d.id : undefined,
                  name: d?.name ?? '',
                  fileName: d?.fileName ?? '',
                  fileType: d?.fileType ?? '',
                  creationDate: parsedDate ?? new Date(0),
                } as BusinessDocument;
              })
              // si jamais on tombe sur une valeur totalement invalide, on l'ignore
              .filter((doc: BusinessDocument | undefined): doc is BusinessDocument => !!doc)
          : [];

        return {
          ...def,

          // core
          id                         : ls.id                         ?? def.id                         ,
          tradeName                  : ls.tradeName                  ?? def.tradeName                  ,
          companyName                : ls.companyName                ?? def.companyName                ,
          legalForm                  : ls.legalForm                  ?? def.legalForm                  ,
          businessRegistrationNumber : ls.businessRegistrationNumber ?? def.businessRegistrationNumber ,
          businessActivityCode       : ls.businessActivityCode       ?? def.businessActivityCode       ,
          businessSector             : ls.businessSector             ?? def.businessSector             ,
          businessActivityDetails    : ls.businessActivityDetails    ?? def.businessActivityDetails    , 

          // adresse
          address     : ls.address     ?? def.address     ,
          address2    : ls.address2    ?? def.address2    ,
          address3    : ls.address3    ?? def.address3    , 
          zipCode     : ls.zipCode     ?? def.zipCode     ,
          city        : ls.city        ?? def.city        ,
          country     : ls.country     ?? def.country     ,
          phoneNumber : ls.phoneNumber ?? def.phoneNumber ,

		  handledByAgentId : ls.handledByAgentId ?? def.handledByAgentId ,
		  VATnumber        : ls.VATnumber ?? def.VATnumber ,


          // dates
          creationDate                             : convertStringToDate(ls.creationDate) ?? def.creationDate  ,
          administrativeValidationDate             : toDateOrNull(ls.administrativeValidationDate)             ,
          financialValidationDate                  : toDateOrNull(ls.financialValidationDate)                  ,
          financialValidationBalanceExpirationDate : toDateOrNull(ls.financialValidationBalanceExpirationDate) ,

          // agents (renommés)
          administrativeValidationAgentId : ls.administrativeValidationAgentId ?? def.administrativeValidationAgentId ,
          financialValidationAgentId      : ls.financialValidationAgentId      ?? def.financialValidationAgentId      ,

          // finance
          financialValidationBalanceValue:
            typeof ls.financialValidationBalanceValue === 'number'
              ? ls.financialValidationBalanceValue
              : toNum(ls.financialValidationBalanceValue),

          // géo (l'API renvoie des strings)
          latitude: toNum(ls.latitude),
          longitude: toNum(ls.longitude),

          // relations
          staffMembers,
          businessDocuments,
        };
      });

      console.log (legalStructures)

      return {
        code: 1,
        comment: 'The retrieval of legal structures is complete.',
        payload: legalStructures,
      };
    } else {
      return handleError<LegalStructure[]>(response.status, 'Non-200 response from API');
    }
  } catch (error) {
    console.log(url, error);

    if (axios.isAxiosError(error)) {
      return handleError<LegalStructure[]>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<LegalStructure[]>(-102, 'Unknown error');
  }
};



export const createLegalStructure = async  ( tradeName                                : string             ,
                                             companyName                              : string             ,
                                             legalForm                                : string             ,
                                             businessRegistrationNumber               : string             ,
                                             businessActivityCode                     : string             ,
                                             businessSector                           : string             ,
                                             businessActivityDetails                  : string             ,
                                             address                                  : string             ,
                                             address2                                 : string             ,
                                             address3                                 : string             ,
                                             zipCode                                  : string             ,
                                             city                                     : string             ,
                                             country                                  : string             ,
                                             phoneNumber                              : string             ,
                                            /* administrativeValidationDate             : Date | null        ,
                                             administrativeValidationAgentId          : number             , 
                                             financialValidationDate                  : Date | null        ,
                                             financialValidationAgentId               : number             , 
                                             financialValidationBalanceValue          : number             ,
                                             financialValidationBalanceExpirationDate : Date | null        , */
											 handledByAgentId                         : number             ,
											 VATnumber                                : string             ,
                                             staffMembers                             : StaffMember[]      ,      
                                             businessDocuments                        : BusinessDocument[] ,
                                             setProgress?                             : ((progress: number) => void) | null ) : Promise<BackendResponse> => {

  const url  = `${API_URLS.createLegalStructure}`;

  console.log ( 'createLegalStructure'                     , url                                                    );
  console.log ( 'tradeName'                                , tradeName                                              );
  console.log ( 'companyName'                              , companyName                                            );
  console.log ( 'legalForm'                                , legalForm                                              );
  console.log ( 'businessRegistrationNumber'               , businessRegistrationNumber                             );
  console.log ( 'businessActivityCode'                     , businessActivityCode                                   );
  console.log ( 'businessSector'                           , businessSector                                         );
  console.log ( 'businessActivityDetails'                  , businessActivityDetails                                );
  console.log ( 'address'                                  , address                                                );
  console.log ( 'address2'                                 , address2                                               );
  console.log ( 'address3'                                 , address3                                               );
  console.log ( 'zipCode'                                  , zipCode                                                );
  console.log ( 'city'                                     , city                                                   );
  console.log ( 'country'                                  , country                                                );
  console.log ( 'phoneNumber'                              , phoneNumber                                            );
/*  console.log ( 'administrativeValidationDate'             , convertDateToString ( administrativeValidationDate , 'yyyy/MM/dd' ) );
  console.log ( 'administrativeValidationAgentId'          , administrativeValidationAgentId.toString()             );
  console.log ( 'financialValidationDate'                  , convertDateToString ( financialValidationDate , 'yyyy/MM/dd' ) );
  console.log ( 'financialValidationAgentId'               , financialValidationAgentId.toString()                  );
  console.log ( 'financialValidationBalanceValue'          , financialValidationBalanceValue.toString()             );
  console.log ( 'financialValidationBalanceExpirationDate' , convertDateToString ( financialValidationBalanceExpirationDate , 'yyyy/MM/dd' ) ); */
  console.log ( 'handledByAgentId'                         , handledByAgentId                                       );
  console.log ( 'VATnumber'                                , VATnumber                                              );
  console.log ( 'staffMembers.length'                      , staffMembers.length.toString()                         );
  console.log ( 'businessDocuments.length'                 , businessDocuments.length.toString()                    );





  const formData = new FormData();

                                                   formData.append ( 'tradeName'                                , tradeName                                              );
                                                   formData.append ( 'companyName'                              , companyName                                            );
                                                   formData.append ( 'legalForm'                                , legalForm                                              );
                                                   formData.append ( 'businessRegistrationNumber'               , businessRegistrationNumber                             );
                                                   formData.append ( 'businessActivityCode'                     , businessActivityCode                                   );
                                                   formData.append ( 'businessSector'                           , businessSector                                         );
                                                   formData.append ( 'businessActivityDetails'                  , businessActivityDetails                                );
                                                   formData.append ( 'address'                                  , address                                                );
                                                   formData.append ( 'address2'                                 , address2                                               );
                                                   formData.append ( 'address3'                                 , address3                                               );
                                                   formData.append ( 'zipCode'                                  , zipCode                                                );
                                                   formData.append ( 'city'                                     , city                                                   );
                                                   formData.append ( 'country'                                  , country                                                );
                                                   formData.append ( 'phoneNumber'                              , phoneNumber                                            );
                                                   formData.append ( 'handledByAgentId'                         , handledByAgentId.toString()                            );
                                                   formData.append ( 'VATnumber'                                , VATnumber                                              );
/*  if (administrativeValidationDate)                formData.append ( 'administrativeValidationDate'             , convertDateToString ( administrativeValidationDate , 'yyyy/MM/dd' )             );
                                                   formData.append ( 'administrativeValidationAgentId'          , administrativeValidationAgentId.toString()             );
  if (financialValidationDate)                     formData.append ( 'financialValidationDate'                  , convertDateToString ( financialValidationDate , 'yyyy/MM/dd' )                  );
                                                   formData.append ( 'financialValidationAgentId'               , financialValidationAgentId.toString()                  );
                                                   formData.append ( 'financialValidationBalanceValue'          , financialValidationBalanceValue.toString()             );
  if (financialValidationBalanceExpirationDate)    formData.append ( 'financialValidationBalanceExpirationDate' , convertDateToString ( financialValidationBalanceExpirationDate , 'yyyy/MM/dd' ) );*/
                                                   formData.append ( 'staffMembers.length'                      , staffMembers.length.toString()                         );
                                                   formData.append ( 'businessDocuments.length'                 , businessDocuments.length.toString()                    );

  staffMembers.forEach((staffMember, index) => {
    if (staffMember.userId)      formData.append ( `staffMember.${index}.userId`      , staffMember.userId.toString() );
    if (staffMember.jobTitle)    formData.append ( `staffMember.${index}.jobTitle`    , staffMember.jobTitle          );
    if (staffMember.email)       formData.append ( `staffMember.${index}.email`       , staffMember.email             );
    if (staffMember.phoneNumber) formData.append ( `staffMember.${index}.phoneNumber` , staffMember.phoneNumber       );
  });
  
  businessDocuments.forEach((businessDocument, index) => {
    if (businessDocument.name)         formData.append ( `businessDocument.${index}.name`         , businessDocument.name         );
    if (businessDocument.fileToUpload) formData.append ( `businessDocument.${index}.fileToUpload` , businessDocument.fileToUpload );
  });
  
  try
   {
    const response = await axios.post (
                                          url      ,
                                          formData ,
                                        { headers: { 'Accept': 'application/ld+json', 'Content-Type': 'multipart/form-data' }   ,
                                           onUploadProgress: (event) => {

		                                        if (event.total)
												 {
                                                  const percentCompleted = Math.round((event.loaded * 100) / event.total);

                                                  if ( setProgress && typeof (setProgress) !== "undefined" )
												   {
                                                    setProgress(percentCompleted);
												   }
                                                 }
                                              }}
                                      );

    if (response.status === 201)
          {
           return {
                    code    : 1,
                    comment : 'Legal structure has been created',
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, 'Error creating the product');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error occurred');
   }
};
